import { merge } from 'lodash'
import types from '../actions/types'

const { UPDATE_INVOICES, RESET_INVOICES } = types

const initialState = {
  data: [],
  next: null
}

function dashboardInvoicesReducer(state = initialState, action = {}) {
  switch (action.type) {
    case UPDATE_INVOICES: {
      return {
        ...state,
        data: merge([...state.data, ...action.data]),
        next: action.next
      }
    }
    case RESET_INVOICES: {
      return {
        ...state,
        data: [],
        next: null
      }
    }
    default:
      return state
  }
}

export default dashboardInvoicesReducer



// WEBPACK FOOTER //
// ./src/alelo-logic/reducers/dashboardInvoicesReducer.js